import BaseBlockContent from '@sanity/block-content-to-react'
import React from 'react'
import { Link, List, ListItem, Typography } from '@material-ui/core'
import { Link as InternalLink } from 'gatsby'
import getReferenceUrl from '../../../../utils/getReferenceUrl'

const customBlock = props => {
  // console.log('BlockContent render customBlock', props)
  if (props.node.listItem === 'bullet' || props.node.listItem === 'number') {
    return (
      <ListItem>
        <Typography variant="body1" component="div">
          {props.children}
        </Typography>
      </ListItem>
    )
  }
  switch (props.node.style) {
    case 'h1':
      return <Typography variant="h1">{props.children}</Typography>
    case 'h2':
      return <Typography variant="h2">{props.children}</Typography>
    case 'h3':
      return <Typography variant="h3">{props.children}</Typography>
    case 'subtitle1':
      return <Typography variant="subtitle1">{props.children}</Typography>
    default:
      return <Typography variant="body1">{props.children}</Typography>
  }
}

const serializers = {
  marks: {
    internalLink: props => {
      // console.log('BlockContent serializer render internalLink', props)
      const { reference } = props.mark

      // Editors might leave the reference empty :/
      if (!reference) {
        return <span>{props.children}</span>
      }
      const url = getReferenceUrl(reference)
      if (reference._type === 'activity') {
        return (
          <a href={url} target="_blank" rel="noopener noreferrer">
            {props.children}
          </a>
        )
      } else {
        return <InternalLink to={url}>{props.children}</InternalLink>
      }
    },
    link: ({ mark, children }) => {
      // console.log('BlockContent serializer render link', mark)
      const { href } = mark
      return (
        <Link href={href} target="_blank" rel="noopener noreferrer">
          {children}
        </Link>
      )
    },
    contactLink: props => {
      const { mark, children } = props
      const { email, subject } = mark
      let mailToUrl = `mailto:${email}`
      if (subject) {
        mailToUrl += `?subject=${subject}`
      }
      return (
        <a href={mailToUrl} target="_blank" rel="noopener noreferrer">
          {children}
        </a>
      )
    }
  },
  types: {
    blockContentObject(props) {
      // console.log('BlockContent render blockObjectContent', props)
      return <BlockContent blocks={props.node.content} />
    },
    customBlock: customBlock,
    activityTextBlock: customBlock
  },
  list(props) {
    // console.log('BlockContent serializer rendering list', props)
    return (
      <List
        component={props.type === 'number' ? 'ol' : 'ul'}
        className={props.type === 'number' ? 'ol' : 'ul'}
      >
        {props.children}
      </List>
    )
  },
  listItem(props) {
    // console.log('BlockContent serializer rendering listItem', props)
    return <ListItem>{props.children}</ListItem>
  }
}

const BlockContent = ({ className, blocks }) => (
  <BaseBlockContent className={className} blocks={blocks} serializers={serializers} />
)

export default BlockContent
